<template>
    <div class="ui form segment">
        <h3 class="ui header">
            Sicurezza
        </h3>
        <div class="ui hidden divider"></div>
        <div class="field">
            <label>Vecchia Password</label>
            <input type="password" v-model="user.oldpassword">
            <div class="ui bottom attached negative mini message" v-if="password_wrong">
                <i class="times icon red"></i>
                La password non è corretta
            </div>
        </div>
        <div class="field">
            <label>Nuova Password</label>
            <input type="password" v-model="user.newpassword" @keyup="check_length">
            <div class="ui bottom attached warning visible mini message" v-if="password_short">
                <i class="warning icon yellow"></i>
                La password deve essere di almeno 10 caratteri
            </div>
        </div>
        <div class="field">
            <label>Conferma Nuova Password</label>
            <input type="password" v-model="user.newpassword_repeat" @keyup="check_repeat">
            <div class="ui bottom attached warning visible mini message" v-if="password_different">
                <i class="warning icon yellow"></i>
                Le password non corrispondono
            </div>
        </div>
        <div class="sixteen wide column">
            <div id="success" class="ui positive hidden message">
                <div class="header">
                    Password Aggiornata!
                </div>
            </div>
            <div id="message" class="ui negative hidden message">
                <div class="header">
                    Attenzione!
                </div>
                <p>{{ message }}</p>
            </div>
        </div>
        <div class="sixteen wide column">
            <button type="button" class="ui positive button" @click="save" :disabled="password_different || !user.newpassword || user.newpassword == ''">
                <i class="sync icon"></i>Aggiorna
            </button>
        </div>
    </div>
</template>
<script type="text/javascript">

import { mapState } from 'vuex'

export default{

    data: () => {
        return {
            message: '',
            password_wrong: false,
            password_short: false,
            password_different: false,
        }
    },

    computed: {
        ...mapState('app', ['user']),
    },

    methods: {
        check_length() {
            if(!this.user.newpassword || this.user.newpassword.length < 10){
                this.password_short = true
            }else{
                this.password_short = false
            }
        },
        check_repeat() {
            if(this.user.newpassword != this.user.newpassword_repeat){
                this.password_different = true
            }else{
                this.password_different = false
            }
        },
        save() {
            if(this.user.newpassword != this.user.newpassword_repeat){
                this.password_different = true
                return false
            }
            this.password_wrong = false
            this.$store.dispatch( 'profile/save' ).then(response => {
                $('#profile button').prop("disabled", false);
                $('#success').removeClass('hidden')
                setTimeout(() => {
                    $('#success').addClass('hidden')
                }, 2000)
            }, error => {
                if(error.response.status == 412){
                    this.password_wrong = true
                    return false
                }
                this.message = error.response.data.message
                $('#message').removeClass('hidden')
                setTimeout(() => {
                    $('#message').addClass('hidden')
                }, 5000)
                $('#profile button').prop("disabled", false);
            })
        },
    }
    
}
</script>